<template>
	<div>
		<div class="mb-4">
			<h1 class="section-title mb-2">Mi Plan</h1>
			<p class="section-lead mb-0">Gestiona tu suscripción y revisa tu historial de pagos</p>
		</div>

		<b-card class="account-card mb-4">
			<template #header>
				<h3 class="card-heading mb-0">
					<i class="fa-regular fa-box mr-2 text-primary"></i>
					Plan Actual
				</h3>
			</template>

			<div class="current-plan-box mb-4">
				<div class="row align-items-center">
					<div class="col-md-8 mb-3 mb-md-0">
						<h3 class="plan-name">Plan Semestral</h3>
						<p class="text-muted mb-3">Activo hasta: 15 Julio 2025</p>
						<ul class="plan-features list-unstyled mb-0">
							<li><i class="fa-regular fa-check text-primary mr-2"></i>15 consultas con Lexi IA</li>
							<li><i class="fa-regular fa-check text-primary mr-2"></i>8 expedientes digitales</li>
							<li><i class="fa-regular fa-check text-primary mr-2"></i>Soporte prioritario</li>
						</ul>
					</div>
					<div class="col-md-4 text-md-right">
						<p class="plan-price mb-0">$1,499</p>
						<p class="text-muted small">/6 meses</p>
						<b-button to="/precios" size="sm" variant="outline-primary" class="mt-2">
							Cambiar plan
						</b-button>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6 mb-3 mb-md-0">
					<div class="usage-box">
						<div class="d-flex justify-content-between mb-2">
							<span class="small font-weight-bold">Consultas con Lexi</span>
							<span class="small text-muted">8 de 15</span>
						</div>
						<div class="progress usage-progress">
							<div class="progress-bar" role="progressbar" style="width: 53%"></div>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="usage-box">
						<div class="d-flex justify-content-between mb-2">
							<span class="small font-weight-bold">Expedientes</span>
							<span class="small text-muted">2 de 8</span>
						</div>
						<div class="progress usage-progress">
							<div class="progress-bar" role="progressbar" style="width: 25%"></div>
						</div>
					</div>
				</div>
			</div>
		</b-card>

		<b-card class="account-card mb-4">
			<template #header>
				<h3 class="card-heading mb-0">
					<i class="fa-regular fa-credit-card mr-2 text-primary"></i>
					Método de Pago
				</h3>
			</template>
			<div class="payment-method d-flex align-items-center justify-content-between">
				<div class="d-flex align-items-center">
					<div class="payment-icon mr-3">
						<i class="fa-regular fa-credit-card"></i>
					</div>
					<div>
						<p class="font-weight-bold mb-0">Visa •••• 4242</p>
						<p class="small text-muted mb-0">Vence 12/26</p>
					</div>
				</div>
				<b-button size="sm" variant="outline-secondary">
					<i class="fa-regular fa-pen-to-square mr-1"></i>
					Editar
				</b-button>
			</div>
		</b-card>

		<b-card class="account-card">
			<template #header>
				<h3 class="card-heading mb-0">
					<i class="fa-regular fa-calendar mr-2 text-primary"></i>
					Historial de Pagos
				</h3>
			</template>
			<div
				v-for="(payment, index) in paymentHistory"
				:key="index"
				class="payment-row d-flex align-items-center justify-content-between"
				:class="{ 'mb-3': index < paymentHistory.length - 1 }"
			>
				<div class="d-flex align-items-center">
					<div class="payment-check mr-3">
						<i class="fa-regular fa-check"></i>
					</div>
					<div>
						<p class="font-weight-bold mb-0">{{ payment.plan }}</p>
						<p class="small text-muted mb-0">{{ payment.date }}</p>
					</div>
				</div>
				<div class="text-right">
					<p class="font-weight-bold mb-1">{{ payment.amount }}</p>
					<button type="button" class="btn-link-invoice">
						<i class="fa-regular fa-download mr-1"></i>
						Factura
					</button>
				</div>
			</div>
		</b-card>
	</div>
</template>

<script>
export default {
	name: 'MyAccountPlan',

	data() {
		return {
			paymentHistory: [
				{ plan: 'Plan Semestral', date: '15 Enero 2025', amount: '$1,499.00' },
				{ plan: 'Plan Mensual', date: '10 Diciembre 2024', amount: '$299.00' },
				{ plan: 'Plan Mensual', date: '10 Noviembre 2024', amount: '$299.00' },
			],
		}
	},
}
</script>
